import { fetchApi } from '@/services/api-client';

export const PERIODS_PATH = '/admin/timetable/periods';

export type PeriodKind = 'lesson' | 'break' | 'activity';

export type MiddaySwapRole = 'lunch' | 'lesson' | null;

export type Period = {
  id: string;
  name: string;
  startTime: string;
  endTime: string;
  kind: PeriodKind;
  middaySwapRole: MiddaySwapRole;
  sortOrder: number;
  active: boolean;
  /** Days this period runs on: 1=Mon … 6=Sat. */
  weekdays: number[];
  createdAt: string;
  updatedAt: string;
};

export const periodsApi = {
  list: () => fetchApi<Period[]>(PERIODS_PATH),
  getById: (id: string) => fetchApi<Period>(`${PERIODS_PATH}/${id}`),
  create: (data: {
    name: string;
    startTime: string;
    endTime: string;
    kind?: PeriodKind;
    middaySwapRole?: MiddaySwapRole;
    sortOrder?: number;
    active?: boolean;
    weekdays?: number[];
  }) => fetchApi<Period>(PERIODS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (
    id: string,
    data: {
      name?: string;
      startTime?: string;
      endTime?: string;
      kind?: PeriodKind;
      middaySwapRole?: MiddaySwapRole;
      sortOrder?: number;
      active?: boolean;
      weekdays?: number[];
    }
  ) => fetchApi<Period>(`${PERIODS_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${PERIODS_PATH}/${id}`, { method: 'DELETE' }),
};
